module.exports = __webpack_public_path__ + "static/media/OnPoint.aef85679.mp3";